import { loanAgainstProperty } from "@/data/loans";
import { useCallback } from "react";
import { LOAN_TYPES } from "@/constants/loanTypes";

import SEO from "@/components/common/SEO";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import PartnerBanks from "@/components/landing/PartnerBanks";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

export default function LoanAgainstProperty() {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...loanAgainstProperty.seo} />

      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...loanAgainstProperty.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...loanAgainstProperty.overview} />

        <LoanBenefits {...loanAgainstProperty.benefits} />

        <LoanTypes {...loanAgainstProperty.types} />

        <LoanEligibility
          {...loanAgainstProperty.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...loanAgainstProperty.documents} />

        <LoanProcess {...loanAgainstProperty.process} />

        <WhyMoneyMart {...loanAgainstProperty.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...loanAgainstProperty.faq} />

        <LoanCTA {...loanAgainstProperty.cta} onApply={scrollToLeadForm} />

        <LeadFormSection
          {...loanAgainstProperty.leadForm}
          loanType="LOAN_AGAINST_PROPERTY"
        />
      </LoanLayout>
    </>
  );
}
